class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.isOpen = false;
    this.searchTerm = '';
    this.recentSearches = JSON.parse(localStorage.getItem('recentSearches')) || [];
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.querySelector('form').addEventListener('submit', this.saveSearchTerm.bind(this));
  }

  onFocus() {
    if (!this.input.value.length) {
      this.renderRecentSearches();
    } else {
      this.getSearchResults(this.input.value.trim());
    }
  }

  onInput() {
    const searchTerm = this.input.value.trim();
    this.searchTerm = searchTerm;

    if (searchTerm.length === 0) {
      this.renderRecentSearches();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  saveSearchTerm(event) {
    event.preventDefault();
    const searchTerm = this.input.value.trim();
    if (searchTerm && !this.recentSearches.includes(searchTerm)) {
      this.recentSearches = [searchTerm, ...this.recentSearches.slice(0, 4)];
      localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    }
  }

  getSearchResults(searchTerm) {
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then((response) => response.text())
      .then((results) => {
        this.predictiveSearchResults.innerHTML = results;
        this.openResults();
      })
      .catch(() => {
        this.closeResults();
      });
  }

  // getSearchResults(searchTerm) {
  //   fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=collection&resources[limit]=10`)
  //     .then((response) => response.text())
  //     .then((results) => {
  //       this.predictiveSearchResults.innerHTML = results;
  //       this.openResults();
  //     })
  //     .catch(() => {
  //       this.closeResults();
  //     });
  // }


// getSearchResults(searchTerm) {
//     fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=collection&resources[limit]=15`)
//       .then((response) => response.text())
//       .then((results) => {
//         this.predictiveSearchResults.innerHTML = results;
//         this.openResults();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(results, "text/html");
//         const collectionLinks = doc.querySelectorAll("[data-collection-handle]");
//         const collectionHandles = Array.from(collectionLinks).map(link => link.dataset.collectionHandle);
//         this.filterCollectionsByProductCount(collectionHandles);
//       })
//       .catch(() => {
//         this.closeResults();
//       });
// }

  
// filterCollectionsByProductCount(collectionHandles) {
//     let validCollections = [];

//     const checkCollection = (handle) => {
//         return fetch(`/collections/${handle}/products.json?limit=1`) 
//             .then(response => response.json())
//             .then(data => {
//                 if (data.products.length >= 1) {
//                     validCollections.push(handle);
//                 }
//             });
//     };

//     Promise.all(collectionHandles.map(checkCollection)).then(() => {
//         this.updateSearchResults(validCollections);
//     });
// }

// updateSearchResults(validCollections) {
//     const allCollections = this.predictiveSearchResults.querySelectorAll("[data-collection-handle]");
    
//     allCollections.forEach(collection => {
//         if (!validCollections.includes(collection.dataset.collectionHandle)) {
//             collection.style.display = "none"; 
//         }
//     });
// }





  

// getSearchResults(searchTerm) {
//     const productRequest = fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product&resources[limit]=10`)
//         .then(response => response.text());

//     const collectionRequest = fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=collection&resources[limit]=10`)
//         .then(response => response.text());

//     Promise.all([productRequest, collectionRequest])
//         .then(([productResults, collectionResults]) => {
//             this.predictiveSearchResults.innerHTML = productResults + collectionResults; // Merge results
//             this.openResults();
//         })
//         .catch(() => {
//             this.closeResults();
//         });
// }



  renderRecentSearches() {
    const recentMarkup = this.recentSearches
      .map((term) => `<li class="recent-search">${term}</li>`)
      .join('');
    this.predictiveSearchResults.innerHTML = `<ul>${recentMarkup}</ul>`;
    this.openResults();
  }

  openResults() {
    this.predictiveSearchResults.style.display = 'block';
    this.isOpen = true;
  }

  closeResults() {
    this.predictiveSearchResults.style.display = 'none';
    this.isOpen = false;
  }
}

customElements.define('predictive-search', PredictiveSearch);
